import { PreviewRecipientPicker } from './preview-recipient-picker.component';

interface PreviewPaneProps {
  html: string | undefined;
  isLoading: boolean;
  isError: boolean;
  /** Currently picked preview-recipient contact-employee id, or `null`. */
  previewRecipientId: number | null;
  onPreviewRecipientChange: (next: number | null) => void;
}

/** Right pane: the backend-rendered email HTML, shown in a sandboxed iframe. */
export function PreviewPane({
  html,
  isLoading,
  isError,
  previewRecipientId,
  onPreviewRecipientChange,
}: PreviewPaneProps) {
  return (
    <div className="eb-preview">
      <div className="eb-preview-head">
        <span className="eb-preview-title">Vorschau</span>
        <PreviewRecipientPicker
          value={previewRecipientId}
          onChange={onPreviewRecipientChange}
        />
        <span className="eb-preview-status">
          {isError
            ? 'Fehler'
            : isLoading
              ? 'Wird aktualisiert…'
              : 'Aktuell'}
        </span>
      </div>

      <div className="eb-preview-stage ds-scroll">
        {isError ? (
          <div className="eb-preview-message">
            Die Vorschau konnte nicht gerendert werden. Bitte prüfen Sie die
            Eingaben und versuchen Sie es erneut.
          </div>
        ) : html === undefined ? (
          <div className="eb-preview-message">Vorschau wird vorbereitet…</div>
        ) : (
          <iframe
            className="eb-preview-frame"
            title="E-Mail-Vorschau"
            sandbox=""
            srcDoc={html}
          />
        )}
      </div>
    </div>
  );
}
